export const attributeFields = `
    fragment attributeFields on Attribute {
        key
        value
    }
`;
